import React, { Fragment } from "react";
import Header from "../components/Header";
import MysorePageDetails from "../templates/MysorePageDetails";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import SEO from '../components/SEO';

const PageServiceDetails = () => {
  return (
    <Fragment>
      <Header />
      <MysorePageDetails />
      <SEO/>
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default PageServiceDetails;
